export default __webpack_public_path__ + "static/media/Equipe6.15871763.png";